<template>
  <mia-modal
    id="search-cars-modal"
    classes="v--modal flex flex-col"
    width="85%"
    height="auto"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <mia-modal-header>
      <h3 class="py-0 my-0">
        Fahrzeuge suchen
      </h3>
    </mia-modal-header>

    <div v-if="!showSearchResults">
      <mia-quick-search
        inline
        :can-change-mode="false"
        @submit="search"
        @reset="reset"
      >
        <template #custom-controls>
          <div class="flex-1">
            <mia-cancel-button
              label="Abbrechen"
              @click="$emit('closed')"
            />
          </div>
        </template>
      </mia-quick-search>
    </div>

    <div v-if="showSearchResults">
      <mia-search-results
        ref="searchResults"
        :column-config="columnConfig"
        :inline="true"
        :actions="actions"
      />

      <mia-modal-footer class="flex items-center justify-between">
        <mia-cancel-button
          label="Abbrechen"
          @click="$emit('closed')"
        />

        <mia-submit-button
          label="Suche anpassen"
          type="button"
          @click="showSearchResults = false"
        />
      </mia-modal-footer>
    </div>
  </mia-modal>
</template>

<script>
import get from 'lodash/get'
import { mapGetters } from 'vuex'
import CancelButton from '@/components/cars/edit/CancelButton.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import QuickSearch from '@/components/cars/search/QuickSearch.vue'
import SearchResults from '@/components/cars/search/SearchResults.vue'
import ActionButtonColumn from '@/components/ui/datatable/columns/ActionButtonColumn.vue'
import { isEmpty } from '@/helpers/utils'

export default {
  name: 'MiaSearchCarsModal',

  components: {
    'mia-cancel-button': CancelButton,
    'mia-quick-search': QuickSearch,
    'mia-search-results': SearchResults,
    'mia-submit-button': SubmitButton
  },

  data() {
    return {
      columnConfig: [
        {
          column: 'id',
          label: 'ID',
          isToggleable: true,
          isDefault: true
        },
        {
          column: 'created',
          label: 'Angelegt',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'fin',
          label: 'FIN',
          isToggleable: true,
          isDefault: true
        },
        {
          column: 'commission_number',
          label: 'Kommissionsnummer',
          isToggleable: true,
          isDefault: true
        },
        {
          column: 'shared',
          label: 'Freigegeben',
          isToggleable: true,
          isDefault: true
        },
        {
          column: 'blocked_end',
          label: 'Reserviert bis',
          isToggleable: true,
          isDefault: true
        },
        {
          column: 'shared_title',
          label: 'Titel',
          isToggleable: true,
          isDefault: true
        },
        {
          column: 'stock',
          label: 'Lagerplatz',
          isToggleable: true,
          isDefault: true
        },
        {
          column: 'manufacturer_color',
          label: 'Farbe',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'net_list_price',
          label: 'UPE Netto (ohne Garantie für Prämienberechnung)',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'net_list_price_at_ordertime',
          label: 'UPE zum Bestellzeitpunkt Netto',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'net_list_price_invoice',
          label: 'UPE aus Rechnung Netto',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'price_customer',
          label: 'Angebotspreis Endkunde',
          isToggleable: true,
          isDefault: true
        },
        {
          column: 'price_partner',
          label: 'Angebotspreis Vermittler',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'price_retailer',
          label: 'Angebotspreis Wiederverkäufer',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'seller',
          label: 'Verkäufer',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'sold_date',
          label: 'Datum Kaufvertrag',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'invoicedate_sold',
          label: 'Rechnungsdatum',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'make',
          label: 'Marke',
          isToggleable: true,
          isDefault: true
        },
        {
          column: 'model',
          label: 'Modell',
          isToggleable: true,
          isDefault: true
        },
        {
          column: 'model_range',
          label: 'Baureihe',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'trimline',
          label: 'Ausstattungslinie',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'category',
          label: 'Kategorie',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'type',
          label: 'Typ',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'powerkw',
          label: 'Leistung',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'model_code',
          label: 'Modellcode',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'fuel',
          label: 'Kraftstoff',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'gearbox_type',
          label: 'Getriebe',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'km',
          label: 'Kilometerstand',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'status',
          label: 'Status',
          isToggleable: true,
          isDefault: true
        },
        {
          column: 'customer',
          label: 'Kunde',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'assignee',
          label: 'Zuständiger',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'expected_dispatch',
          label: 'Erwartete Auslieferung',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'dispatch',
          label: 'Terminierte Auslieferung',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'certificate',
          label: 'Brieflagerplatz',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'numberplate',
          label: 'Kennzeichen',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'initialregistration',
          label: 'Erstzulassung',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'initialregistration_on_customer',
          label: 'Erstzulassung auf Kunden',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'wintertyres',
          label: 'Winterreifen',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'notes',
          label: 'Anmerkungen',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'provision_requested',
          label: 'Prämien angefordert',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'provision_paid',
          label: 'Prämien bezahlt',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'revenue',
          label: 'Ertrag',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'financial_values',
          label: 'Finanzierungsertrag',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'accessories_revenue',
          label: 'Zubehörertrag',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'sold_channel',
          label: 'Vertriebskanal',
          isToggleable: true,
          isDefault: false
        },
        {
          column: 'actions',
          label: 'Aktion',
          isToggleable: false,
          isDefault: true
        }
      ],
      queryConfig: Object.freeze({
        in: [
          'status',
          'type',
          'category',
          'fuel',
          { field: 'gearbox_type', formField: 'gearboxType' }
        ],
        equals: [
          { field: 'customer.id', formField: 'customer.id' },
          {
            field: 'shared',
            formField: 'published',
            when: () => this.form.published !== '',
            callback: ({ query, field, value }) => query.conditions.push({ field, type: 'EQUALS', value: value === 'true' ? 'Y' : 'N' })
          },
          { field: 'stock.id', formField: 'stockNumber' },
          { field: 'certificate.id', formField: 'certificateSlot' },
          'closed',
          'id'
        ],
        startsWith: [
          { field: 'numberplate', formField: 'numberPlate' }
        ],
        contains: [
          { field: 'shared_title', formField: 'title' },
          'fin',
          { field: 'commission_number', formField: 'commissionNumber' }
        ],
        greaterThanEquals: [
          {
            field: 'price_customer',
            formField: 'priceCustomerFrom',
            when: () => !isEmpty(this.form.priceCustomerFrom) && isEmpty(this.form.priceCustomerTo)
          },
          {
            field: 'km',
            formField: 'mileageFrom',
            when: () => !isEmpty(this.form.mileageFrom) && isEmpty(this.form.mileageTo)
          },
          {
            field: 'powerkw',
            formField: 'powerFrom',
            when: () => !isEmpty(this.form.powerFrom) && isEmpty(this.form.powerTo)
          },
          {
            field: 'initialregistration',
            formField: 'initialRegistrationFrom',
            when: () => !isEmpty(this.form.initialRegistrationFrom) && isEmpty(this.form.initialRegistrationTo)
          },
          {
            field: 'invoicedate_sold',
            formField: 'invoiceDateSoldFrom',
            when: () => !isEmpty(this.form.invoiceDateSoldFrom) && isEmpty(this.form.invoiceDateSoldTo)
          },
          {
            field: 'dispatch',
            formField: 'dispatchFrom',
            when: () => !isEmpty(this.form.dispatchFrom) && isEmpty(this.form.dispatchTo)
          }
        ],
        lessThanEquals: [
          {
            field: 'price_customer',
            formField: 'priceCustomerTo',
            when: () => isEmpty(this.form.priceCustomerFrom) && !isEmpty(this.form.priceCustomerTo)
          },
          {
            field: 'km',
            formField: 'mileageTo',
            when: () => isEmpty(this.form.mileageFrom) && !isEmpty(this.form.mileageTo)
          },
          {
            field: 'powerkw',
            formField: 'powerTo',
            when: () => isEmpty(this.form.powerFrom) && !isEmpty(this.form.powerTo)
          },
          {
            field: 'initialregistration',
            formField: 'initialRegistrationTo',
            when: () => isEmpty(this.form.initialRegistrationFrom) && !isEmpty(this.form.initialRegistrationTo)
          },
          {
            field: 'invoicedate_sold',
            formField: 'invoiceDateSoldTo',
            when: () => isEmpty(this.form.invoiceDateSoldFrom) && !isEmpty(this.form.invoiceDateSoldTo)
          },
          {
            field: 'dispatch',
            formField: 'dispatchTo',
            when: () => isEmpty(this.form.dispatchFrom) && !isEmpty(this.form.dispatchTo)
          }
        ],
        between: [
          { field: 'price_customer', formFields: ['priceCustomerFrom', 'priceCustomerTo'] },
          { field: 'km', formFields: ['mileageFrom', 'mileageTo'] },
          { field: 'powerkw', formFields: ['powerFrom', 'powerTo'] },
          { field: 'initialregistration', formFields: ['initialRegistrationFrom', 'initialRegistrationTo'] },
          { field: 'invoicedate_sold', formFields: ['invoiceDateSoldFrom', 'invoiceDateSoldTo'] },
          { field: 'dispatch', formFields: ['dispatchFrom', 'dispatchTo'] }
        ]
      }),
      actions: {
        label: 'Aktion',
        field: '',
        sortable: false,
        headerAlign: 'left',
        align: 'right',
        component: ActionButtonColumn,
        meta: {
          actions: [
            {
              label: 'Auswählen',
              attrs: {
                title: 'Auswählen'
              },
              onClick: (car) => {
                this.$emit('select', car)
              }
            }
          ]
        }
      },
      isSubmitted: false,
      showSearchResults: false
    }
  },

  computed: {
    ...mapGetters('search', [
      'form',
      'visibleColumns'
    ])
  },

  methods: {
    async search() {
      this.$wait.start('searching cars')

      try {
        const query = this.compileQuery()

        if (this.form.dealerShared !== '' && (this.form.dealerShared === true || this.form.dealerShared === 'true')) {
          query.shared = true
        }

        const { data } = await window.axios.post(`${process.env.VUE_APP_PROVIDER}/car/searchCars`, query)

        const cars = data.map(car => ({
          ...car,
          certificateSlotId: car.certificateSlot.id,
          certificateSlotTitle: car.certificateSlot.title,
          customerId: car.customers.id,
          customerName: car.customers.name,
          customerFirstname: car.customers.firstname,
          assigneeId: car.usersAssignee.id,
          assigneeLastname: car.usersAssignee.lastname,
          assigneeFirstname: car.usersAssignee.firstname,
          make: car.mobileMake.make,
          model: car.mobileModel.model,
          stockSlotId: (car.stockSlot || {}).id,
          stockSlotTitle: (car.stockSlot || {}).title,
          sellerId: (car.sellers || {}).id,
          sellerFirstname: (car.sellers || {}).firstname,
          sellerLastname: (car.sellers || {}).lastname,
          salesChannelTitle: (car.saleschannel || {}).title,
          blockedEnd: (car.carsBlocked || {}).end
        }))
        this.$store.commit('search/setCars', cars)

        this.showSearchResults = true
        this.isSubmitted = true

        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$refs.searchResults.show()
          })
        })
      } catch (e) {
        console.log(e)

        window.eventBus.$emit('mia-error', {
          error: ['Suche fehlgeschlagen.']
        })
      } finally {
        this.$wait.end('searching cars')
      }
    },

    reset() {
      this.$store.dispatch('search/reset')
      this.$store.dispatch('search/resetCars')

      window.eventBus.$emit('mia-info', {
        info: ['Suche erfolgreich zurückgesetzt.']
      })
    },

    compileQuery() {
      const query = {
        type: 'CONJUNCTION',
        conditions: []
      }

      const fields = [
        'id',
        'created',
        'fin',
        'commission_number',
        'shared_title',
        'manufacturer_color',
        'price_customer',
        'price_partner',
        'price_retailer',
        'seller.id',
        'seller.firstname',
        'seller.lastname',
        'make',
        'model',
        'model_range',
        'trimline',
        'category',
        'powerkw',
        'fuel',
        'gearbox_type',
        'type',
        'km',
        'status',
        'customer.id',
        'customer.firstname',
        'customer.name',
        'assignee.id',
        'assignee.firstname',
        'assignee.lastname',
        'stock.id',
        'stock.title',
        'expected_dispatch',
        'dispatch',
        'certificate.id',
        'certificate.title',
        'tax',
        'shared',
        'numberplate',
        'initialregistration',
        'initialregistration_on_customer',
        'price_purchased',
        'invoicedate_sold',
        'sold_date',
        'closed',
        'model_code',
        'wintertyres',
        'notes',
        'provision_requested',
        'provision_paid',
        'revenue',
        'financial_values',
        'accessories_revenue',
        'sold_channel.title',
        'blocked.end',
        'dealer',
        'net_list_price',
        'net_list_price_at_ordertime',
        'net_list_price_invoice',
        'blocked.end'
      ]

      // Add fields based on query config
      Object.entries(this.queryConfig).forEach(([queryType, fieldConfigs]) => {
        // Determine the query handler method with the name of "add + queryTypeInUcFirst + Query", e.g. "addContainsQuery"
        const queryHandler = `add${queryType.substring(0, 1).toUpperCase()}${queryType.substring(1)}Query`

        if (this[queryHandler] === undefined) {
          throw new Error(`There is no handler for "${queryType}" with the name of "${queryHandler}"`)
        }

        fieldConfigs.forEach((field) => {
          let fieldConfig = { query }

          // Handle fields which map 1:1 to the backend field:form field
          if (typeof field === 'string') {
            fieldConfig.field = field
            fieldConfig.formField = field
            fieldConfig.when = value => !isEmpty(value)
          }

          // Handle "custom" fields, which are already pre-configured in the way they should be handled
          if (typeof field === 'object') {
            fieldConfig = { ...fieldConfig, ...field }
          }

          if (!['string', 'object'].includes(typeof field)) {
            throw new Error(`Unable to handle ${typeof field} fields.`)
          }

          this[queryHandler](fieldConfig)
        })
      })

      // Add fields that require custom logic
      this.addCarsQuery(query)

      return { query, fields }
    },

    addInQuery({
      query,
      field,
      formField,
      when = values => values.length > 0,
      callback = null
    }) {
      const value = get(this.form, formField, undefined)

      if (value === undefined) {
        return
      }

      // Check if the field should be included in the query
      if (!when(value)) {
        return
      }

      // Check if there is a custom callback to handle the query
      if (typeof callback === 'function') {
        callback({
          query, field, formField, value
        })
        return
      }

      query.conditions.push({ field, type: 'IN', value })
    },

    addEqualsQuery({
      query,
      field,
      formField,
      when = value => !isEmpty(value),
      callback = null
    }) {
      const value = get(this.form, formField, undefined)

      if (value === undefined) {
        return
      }

      // Check if the field should be included in the query
      if (!when(value)) {
        return
      }

      // Check if there is a custom callback to handle the query
      if (typeof callback === 'function') {
        callback({
          query, field, formField, value
        })
        return
      }

      query.conditions.push({ field, type: 'EQUALS', value })
    },

    addStartsWithQuery({
      query,
      field,
      formField,
      when = value => !isEmpty(value),
      callback = null
    }) {
      const value = get(this.form, formField, undefined)

      if (value === undefined) {
        return
      }

      // Check if the field should be included in the query
      if (!when(value)) {
        return
      }

      // Check if there is a custom callback to handle the query
      if (typeof callback === 'function') {
        callback({
          query, field, formField, value
        })
        return
      }

      query.conditions.push({ field, type: 'STARTS_WITH', value })
    },

    addContainsQuery({
      query,
      field,
      formField,
      when = value => !isEmpty(value),
      callback = null
    }) {
      const value = get(this.form, formField, undefined)

      if (value === undefined) {
        return
      }

      // Check if the field should be included in the query
      if (!when(value)) {
        return
      }

      // Check if there is a custom callback to handle the query
      if (typeof callback === 'function') {
        callback({
          query, field, formField, value
        })
        return
      }

      query.conditions.push({ field, type: 'CONTAINS', value })
    },

    addGreaterThanEqualsQuery({
      query,
      field,
      formField,
      when = value => !isEmpty(value),
      callback = null
    }) {
      const value = get(this.form, formField, undefined)

      if (value === undefined) {
        return
      }

      // Check if the field should be included in the query
      if (!when(value)) {
        return
      }

      // Check if there is a custom callback to handle the query
      if (typeof callback === 'function') {
        callback({
          query, field, formField, value
        })
        return
      }

      query.conditions.push({ field, type: 'GREATER_THAN_EQUALS', value })
    },

    addLessThanEqualsQuery({
      query,
      field,
      formField,
      when = value => !isEmpty(value),
      callback = null
    }) {
      const value = get(this.form, formField, undefined)

      if (value === undefined) {
        return
      }

      // Check if the field should be included in the query
      if (!when(value)) {
        return
      }

      // Check if there is a custom callback to handle the query
      if (typeof callback === 'function') {
        callback({
          query, field, formField, value
        })
        return
      }

      query.conditions.push({ field, type: 'LESS_THAN_EQUALS', value })
    },

    addBetweenQuery({
      query,
      field,
      formFields,
      when = value => !isEmpty(value),
      callback = null
    }) {
      const values = formFields.map(formField => get(this.form, formField, undefined))

      if (values.some(value => value === undefined)) {
        return
      }

      // Check if the field should be included in the query
      const whens = values.map(value => when(value))

      if (whens.some(result => result === false)) {
        return
      }

      // Check if there is a custom callback to handle the query
      if (typeof callback === 'function') {
        callback({
          query, field, formFields, values
        })
        return
      }

      query.conditions.push({ field, type: 'BETWEEN', value: values })
    },

    addCarsQuery(query) {
      const validMakes = this.form.makes.filter(make => !isEmpty(make.make))

      if (validMakes.length === 0) return

      const subQuery = {
        type: 'DISJUNCTION',
        conditions: validMakes.map((make) => {
          const makeQuery = {
            type: 'CONJUNCTION',
            conditions: []
          }

          makeQuery.conditions.push({
            field: 'make',
            type: 'EQUALS',
            value: make.make
          })

          if (!isEmpty(make.model)) {
            makeQuery.conditions.push({
              field: 'model',
              type: 'EQUALS',
              value: make.model
            })
          }

          if (!isEmpty(make.modelRange)) {
            makeQuery.conditions.push({
              field: 'model_range',
              type: 'EQUALS',
              value: make.modelRange
            })
          }

          if (!isEmpty(make.trimline)) {
            makeQuery.conditions.push({
              field: 'trimline',
              type: 'EQUALS',
              value: make.trimline
            })
          }

          return makeQuery
        })
      }

      query.conditions.push(subQuery)
    }
  }
}
</script>
